// extracted by mini-css-extract-plugin
export default {"info":"info__008c4e2d"};